module.exports = __webpack_public_path__ + "img/system.f956fd63.png";